import React, { useState } from 'react'

import { Form, Button, Alert, ListGroup } from 'react-bootstrap'

import toast from 'react-hot-toast'

import { fetchAutoTranscribeStatus } from '../api'

import UploadBar from '../UploadBar'

import TranscriptList from '../TranscriptList'

import { languages } from '../../Utils/languages.js'

export default (props) => {
    const {
        handleAutoTranscribe,
        refreshMediaData,
        id,
        pendingASRs,
        mediaData
    } = props


    const [activeSort, setActiveSort] = useState('createdAt');
    const [activeSortType, setActiveSortType] = useState('desc');

    const renderCurrentJobs = () => {
        if (pendingASRs.length === 0) {
            return <Alert variant="dark">No jobs running currently.</Alert>
        }

        return (
            <ListGroup>
                {pendingASRs.map((asr) => (
                    <ListGroup.Item key={asr['_id']}>
                        <div>{JSON.stringify(asr)}</div>
                        <div className="mt-3">
                            <Button
                                variant="outline-secondary"
                                type="button"
                                size="sm"
                                onClick={() => {
                                    handleRefreshAutoTranscribe(asr['asrId'])
                                }}
                            >
                                Refresh
                            </Button>
                        </div>
                    </ListGroup.Item>
                ))}
            </ListGroup>
        )
    }

    const handleRefreshAutoTranscribe = async (asrId) => {
        toast
            .promise(
                fetchAutoTranscribeStatus(id, asrId),
                {
                    loading: `Checking status for ASR Request: ${asrId}`,
                    success: (data) => `${data}`,
                    error: (err) => `${err}`,
                },
                {
                    error: {
                        duration: 3000,
                        icon: '🕑',
                    },
                }
            )
            .then((data) => {
                // console.log(data)
                refreshMediaData()
            })
    }


    const handleTranscriptSorting = (event) => {
        var _sort = event.target.value.split('_');
        var sort = _sort[0];
        var type = _sort[1];

        setActiveSort(sort);
        setActiveSortType(type)
    }


    return (
        <div className="px-2 py-4 d-flex flex-column">
            <div>
                <h3>Auto Transcribe</h3>
                <h5 className="mt-4">Current Running Jobs</h5>
                <div>{renderCurrentJobs()}</div>
                <h5 className="mt-3">Send a new transcription job</h5>
                <div className="mt-3 p-4 border rounded-3 d-flex flex-column">
                    <Form onSubmit={handleAutoTranscribe}>
                        <Form.Group controlId="languageSelect">
                            <Form.Label>Language</Form.Label>
                            <Form.Control as="select" name="language" custom>
                                {languages.langData.map((item, index) => {
                                    return (
                                        <>
                                            <option value={item.val}>{item.lng} {'  '} {'(' + item.desc + ')'}</option>
                                        </>
                                    )
                                })}
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="audioTypeSelect">
                            <Form.Label>Audio Type</Form.Label>
                            <Form.Control as="select" name="audioType" custom>
                                <option value="closetalk">Close Talk</option>
                                <option value="telephony">Telephony</option>
                            </Form.Control>
                        </Form.Group>
                        <Form.Group controlId="audioTrackSelect">
                            <Form.Label>Audio Track</Form.Label>
                            <Form.Control as="select" name="audioTrack" custom>
                                <option value="single">Single Channel</option>
                                <option value="multi">Multi Channel</option>
                            </Form.Control>
                        </Form.Group>
                        <Button variant="primary" type="submit">
                            Submit
                        </Button>
                    </Form>
                </div>
            </div>
            <div className="mt-4">
                <h3 className="mb-4">Upload Transcript</h3>
                <UploadBar
                    actionDialogue="Select Transcript"
                    mediaId={id}
                    uploadUrl="upload/transcript"
                    transcriptType="transcript"
                    onSuccess={refreshMediaData}
                />
            </div>
            <div className="mt-4">
                <div className='d-flex flex-row justify-content-between'>
                    <div className="md-4">
                        <h4>Transcripts</h4>
                    </div>

                    <div className="md-8">
                        <select onChange={handleTranscriptSorting} class="custom-select">
                            <option value="createdAt_desc" selected>Sort By Created Date (Latest)</option>
                            <option value="createdAt_asc">Sort By Created Date (Earliest)</option>
                            <option value="name_asc">Sort By Name (A-Z)</option>
                            <option value="name_desc">Sort By Name (Z-A)</option>
                        </select>
                    </div>
                </div>

                <div>
                    <TranscriptList
                        id={id}
                        type="transcript"
                        activeSort={activeSort}
                        activeSortType={activeSortType}
                        mediaData={mediaData}
                        refreshMediaData={refreshMediaData}
                    />
                </div>
            </div>
        </div>
    )
}
